/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CheckSquareIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M10 9c-.562 0-1 .5-1 1v20c0 .563.438 1 1 1h20c.5 0 1-.437 1-1V10c0-.5-.5-1-1-1zm-4 1c0-2.187 1.75-4 4-4h20c2.188 0 4 1.813 4 4v20c0 2.25-1.812 4-4 4H10c-2.25 0-4-1.75-4-4zm21.063 7.063-8 8c-.625.625-1.563.625-2.125 0l-4-4a1.37 1.37 0 0 1 0-2.063c.562-.625 1.5-.625 2.124 0L18 21.938l6.938-7a1.47 1.47 0 0 1 2.062 0c.625.624.625 1.562 0 2.124z"/>}
        </IconWrapper>);
}
